package com.arena_web.ui.localization

object AppStringsES : AppStrings {

    // language selector
    override val headerProfileLanguage = "Idioma"
    override val headerProfileLanguageRecommended = "Recomendado"

    // common
    override val commonSeeAll = "Ver todo"
    override val commonNo = "No"
    override val commonYes = "Sí"
    override val commonConfirm = "Confirmar"
    override val commonSend = "Enviar"
    override val commonError = "Error"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Activar sonido"
    override val chatMenuMute = "Silenciar"
    override val chatMenuInviteMembers = "Invitar miembros"
    override val chatMenuLeaveGroup = "Salir del grupo"
    override val chatMenuDeleteChat = "Eliminar chat"
    override fun chatRemoveMemberTitle(name: String) = "¿Eliminar a $name?"
    override fun chatRemoveMemberWarning(name: String) = "¿Eliminar a $name del grupo? Esta acción no se puede deshacer."
    override val chatRemoveMemberAction = "Eliminar"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name está escribiendo..."
    override fun chatTypingMany(count: Int) = "$count personas escribiendo..."
    override fun chatMembersCount(count: Int) = "$count miembros"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count miembros, $online en línea"
    override val chatOnline = "En línea"
    override val chatOffline = "Desconectado"
    override val chatEditCommunityTitle = "Editar comunidad"
    override val chatCommunityNameLabel = "Nombre de la comunidad"
    override val chatCommunityNamePlaceholder = "Escribe el nombre de la comunidad..."
    override val chatSaving = "Guardando..."
    override val chatMessageInputPlaceholder = "Escribe un mensaje..."
    override val chatInviteMembersTitle = "Invitar miembros"
    override val chatSearchFriendsPlaceholder = "Buscar amigos..."
    override val chatNoFriendsToInvite = "No hay amigos para invitar"
    override val chatNoResults = "Sin resultados"
    override val chatInviting = "Invitando..."
    override val chatInvite = "Invitar"
    override fun chatInviteCount(count: Int) = "Invitar ($count)"
    override val chatPanelTitle = "Chat de Arena"
    override val chatSearchPlaceholder = "Buscar chat"
    override val chatFilterAll = "Todos"
    override val chatFilterDirect = "Directos"
    override val chatFilterCommunity = "Comunidad"
    override val chatNoChatsFound = "No se encontraron chats"
    override val chatNoConversationsYet = "Aún no hay conversaciones"
    override val chatNewChatTitle = "Nuevo chat"
    override val chatTabDirectMessage = "Mensaje directo"
    override val chatTabCommunity = "Comunidad"
    override val chatSearchPeoplePlaceholder = "Busca a personas que sigues..."
    override val chatNotFollowingAnyone = "Aún no sigues a nadie"
    override val chatCreating = "Creando..."
    override val chatCreateCommunity = "Crear comunidad"
    override val chatSelectConversation = "Selecciona una conversación"
    override fun chatReplyTo(name: String) = "Responder a $name"
    override val chatUnknownSender = "Desconocido"
    override val chatUploading = "Subiendo..."
    override val chatEditingMessage = "Editando mensaje"
    override val chatSearchInChatPlaceholder = "Buscar en el chat..."
    override fun chatSearchResultsFound(count: Int) = "$count encontrados"
    override val chatGroupInfoTitle = "Info del grupo"
    override val chatUserInfoTitle = "Info del usuario"
    override val chatDeleteChatAction = "Eliminar chat"
    override val chatDeleteGroupAction = "Eliminar grupo"
    override val chatLeaveGroupAction = "Salir del grupo"
    override val chatLastSeenRecently = "última vez hace poco"
    override val chatNotificationsLabel = "Notificaciones"
    override val chatTabMembers = "Miembros"
    override val chatTabMedia = "Multimedia"
    override val chatTabFiles = "Archivos"
    override val chatTabLinks = "Enlaces"
    override val chatLoading = "Cargando..."
    override val chatNoMediaYet = "Aún no hay multimedia"
    override val chatNoFilesYet = "Aún no hay archivos"
    override val chatUnknownFile = "Archivo desconocido"
    override val chatNoLinksYet = "Aún no hay enlaces"
    override val chatNoMembers = "Sin miembros"
    override val chatRoleOwner = "Propietario"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "editado"
    override val chatFileFallback = "Archivo"
    override val chatMenuReply = "Responder"
    override val chatMenuPin = "Fijar"
    override val chatEmptyTitle = "Aún no hay chats"
    override val chatEmptySubtitle = "Inicia una conversación para ver tus mensajes aquí."
    override val chatUnnamed = "Sin nombre"
    override val chatNoMessagesYet = "Aún no hay mensajes"
    override val chatRoomEmptyTitle = "Aún no hay mensajes"
    override val chatRoomEmptySubtitle = "Saluda para iniciar la conversación."
    override fun chatMembersHeader(count: Int) = "Miembros ($count)"
    override val chatNoMediaSharedYet = "Aún no se ha compartido multimedia"
    override val chatNoFilesSharedYet = "Aún no se han compartido archivos"
    override val chatNoLinksSharedYet = "Aún no se han compartido enlaces"

    // widget
    override val widgetDismiss = "Descartar"
    override val widgetSomethingWentWrong = "Algo salió mal"
    override val widgetTryAgain = "Inténtalo de nuevo"
    override val widgetCookieTitle = "Usamos cookies"
    override val widgetCookieMessage = "Este sitio web usa cookies para garantizarte la mejor experiencia."
    override val widgetCookieDecline = "Rechazar"
    override val widgetCookieAccept = "Aceptar"
    override val widgetAddInterval = "Añadir intervalo"
    override val widgetSendMessage = "Enviar mensaje"
    override val widgetPrevious = "Anterior"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Activo"
    override val widgetStatusDebtor = "Deudor"
    override val widgetStatusInactive = "Inactivo"
    override val widgetUnpaid = "sin pagar"
    override val widgetStatusInProgress = "En curso"
    override val widgetStatusUpcoming = "Próximo"
    override val widgetStatusPending = "Pendiente"
    override val widgetStatusCompleted = "Completado"
    override fun widgetFieldLabel(number: String) = "Cancha $number"
    override val widgetYearly = "Anual"
    override val widgetAllFields = "Todas las canchas"
    override val widgetPreviousMonth = "Mes anterior"
    override val widgetNextMonth = "Mes siguiente"
    override val widgetSortAscending = "Orden ascendente"
    override val widgetSortDescending = "Orden descendente"
    override val widgetChecked = "Marcado"

    // form
    override val formSelectPlaceholder = "Seleccionar..."

    // common
    override val commonCancel = "Cancelar"
    override val commonSave = "Guardar"
    override val commonDelete = "Eliminar"
    override val commonEdit = "Editar"
    override val commonNext = "Siguiente"
    override val commonRetry = "Reintentar"
    override val commonSearch = "Buscar"

    // event
    override val eventMatchEndedTitle = "EL PARTIDO TERMINÓ"
    override val eventMatchEndedSubtitle = "Califica a los jugadores para actualizar sus clasificaciones personales."
    override val eventTabMatchInfo = "Info del partido"
    override val eventTabLineups = "Alineaciones"
    override val eventTabMedia = "Multimedia"
    override val eventCreateTeam = "Crear equipo"
    override val eventCancelEventQuestion = "¿Cancelar evento?"
    override val eventDeleteEventQuestion = "¿Eliminar evento?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" se marcará como cancelado."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" se eliminará permanentemente."
    override val eventCancelNoticeParticipants = "Se notificará al resto de participantes. El chat y el historial siguen disponibles."
    override val eventDeleteNoticeMedia = "La imagen del evento y el chat también se eliminarán."
    override val eventKeepEvent = "Mantener evento"
    override val eventCancelling = "Cancelando..."
    override val eventDeleting = "Eliminando..."
    override val eventCancelEvent = "Cancelar evento"
    override val eventMatchPerformanceTitle = "Rendimiento del partido"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Estadística"
    override val eventProPlusStatDescription = "Precisión de tiros, pases completados y posesión del balón en detalle."
    override val eventLoadingMedia = "Cargando multimedia..."
    override val eventDeleteMediaQuestion = "¿Eliminar multimedia?"
    override val eventDeleteMediaMessage = "Este archivo se eliminará del evento para todos."
    override val eventNoMediaYet = "Aún no hay multimedia"
    override val eventNoMediaDescription = "Las fotos y videos de este partido aparecerán aquí."
    override val eventInviteTeamTitle = "Invitar equipo"
    override val eventSearchTeamsLabel = "Buscar equipos"
    override val eventSearchTeamsPlaceholder = "Escribe el nombre del equipo..."
    override val eventSearching = "Buscando..."
    override val eventNoTeamsFound = "No se encontraron equipos"
    override fun eventTeamRating(rating: String) = "Valoración $rating"
    override fun eventTeamMembersCount(count: Int) = "$count miembros"
    override val eventInviteStatusAccepted = "Aceptado"
    override val eventInviteStatusDeclined = "Rechazado"
    override val eventInviteStatusInvited = "Invitado"
    override val eventInvite = "Invitar"
    override val eventStartEventQuestion = "¿Iniciar evento?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" pasará a estar en vivo."
    override val eventStartNotice = "Se cerrarán las inscripciones y comenzará el partido."
    override fun eventPendingRequestOne(count: Int) = "$count solicitud pendiente"
    override fun eventPendingRequestsMany(count: Int) = "$count solicitudes pendientes"
    override val eventPendingRequestsSubtitle = "Estos jugadores pidieron unirse pero aún no han sido aprobados."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count jugador sin equipo"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count jugadores sin equipo"
    override val eventTeamlessSubtitle = "Están confirmados pero no asignados a ningún equipo."
    override val eventStarting = "Iniciando..."
    override val eventStartAnyway = "Iniciar igualmente"
    override val eventMonthJanuary = "Enero"
    override val eventMonthFebruary = "Febrero"
    override val eventMonthMarch = "Marzo"
    override val eventMonthApril = "Abril"
    override val eventMonthMay = "Mayo"
    override val eventMonthJune = "Junio"
    override val eventMonthJuly = "Julio"
    override val eventMonthAugust = "Agosto"
    override val eventMonthSeptember = "Septiembre"
    override val eventMonthOctober = "Octubre"
    override val eventMonthNovember = "Noviembre"
    override val eventMonthDecember = "Diciembre"
    override val eventVs = "vs"
    override val eventTeamsLabel = "equipos"
    override val eventPlayersLabel = "jugadores"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Finalizado"
    override val eventLeadersEmptyWinGame = "Gana un partido para subir en la clasificación."
    override val eventLeadersEmptyFirstScore = "Sé el primero en marcar y lidera la clasificación."
    override val eventLeadersEmptyTakeSet = "Gana un set para quedarte con el primer puesto."
    override val eventLeadersEmptyFirstAssist = "Sé el primero en dar un pase decisivo."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Jugador"
    override val eventCreateTeamSubtitle = "Arma tu equipo para el partido"
    override val eventTeamNameLabel = "Nombre del equipo"
    override val eventTeamNameRequired = "El nombre del equipo es obligatorio"
    override val eventTeamColorLabel = "Color del equipo"
    override val eventTeamColorSubtitle = "Elige el color de tu equipo"
    override val eventTeamNamePlaceholder = "Escribe el nombre del equipo..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Jugadores"
    override val eventChatWaitingApproval = "Esperando aprobación"
    override val eventChatConfirmingSpot = "Confirmando tu lugar"
    override val eventChatLocked = "El chat está bloqueado"
    override val eventChatWaitingApprovalSubtitle = "Cuando el admin confirme tu solicitud podrás chatear con el equipo."
    override val eventChatConfirmingSpotSubtitle = "Tu solicitud está en proceso. El chat se desbloquea en cuanto entres."
    override val eventChatPrivateSubtitle = "Este es un evento privado. Solicita unirte y espera la aprobación del admin."
    override val eventChatLockedSubtitle = "Debes unirte a este partido para ver la conversación y hablar con otros jugadores."
    override val eventJoinEvent = "Unirse al evento"
    override val eventChatNoMessages = "Aún no hay mensajes"
    override val eventChatNoMessagesSubtitle = "Inicia la conversación con tu equipo."
    override val eventTeamSectionTitle = "Equipo"
    override val eventDeleteTeam = "Eliminar equipo"
    override val eventViewProfile = "Ver perfil"
    override val eventRemoveAdmin = "Quitar admin"
    override val eventMakeAdmin = "Hacer admin"
    override val eventRemoveFromTeam = "Eliminar del equipo"
    override val eventRemoveFromEvent = "Eliminar del evento"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count equipos"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max jugadores"
    override fun eventPlayersCount(count: Int) = "$count jugadores"
    override val eventStatusLive = "Live"
    override val eventLeave = "Salir"
    override val eventStart = "Iniciar"
    override val eventJoin = "Unirse"
    override val eventStatusPending = "Pendiente"
    override val eventStatusCanceled = "Cancelado"
    override val eventPendingApprovalBadge = "Pendiente de aprobación"
    override val eventRatePerformanceTitle = "Calificar desempeño"
    override val eventRateVoteCounts = "¡Tu voto cuenta!"
    override val eventCommunityRating = "Valoración de la comunidad"
    override val eventSubmitRating = "Enviar valoración"
    override val eventSubmitting = "Enviando..."
    override val eventAddMediaTitle = "Añadir multimedia"
    override val eventUploadMedia = "Subir multimedia"
    override val eventDropMediaHere = "Arrastra tu foto y video aquí"
    override val eventMaxFileSize = "máx. 30 MB"
    override val eventSelectedLabel = "Seleccionados"
    override val eventClearAll = "Borrar todo"
    override val eventAddToTeam = "Añadir al equipo"
    override val eventMakeSubstitution = "Hacer una sustitución"
    override val eventViewProfileSheet = "Ver perfil"
    override fun eventSwapWith(name: String) = "Sustituir a $name por"
    override val eventEndMatch = "Terminar partido"
    override val eventReset = "Reiniciar"
    override val eventLeadersEmptyWinGameShort = "Gana un partido para subir en la clasificación"
    override val eventLeadersEmptyScoreFirst = "Marca primero y lidera la clasificación"
    override val eventLeadersEmptyTakeSetShort = "Gana un set para quedarte con el primer puesto"
    override val eventLeadersEmptyWinningAssist = "Da la asistencia ganadora"
    override val eventRatePlayersSubtitle = "Califica a los jugadores para actualizar el Top Rankings"
    override val eventGenericError = "Algo salió mal"
    override val eventDeleteTeamQuestion = "¿Eliminar equipo?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" se eliminará de este evento. Los jugadores asignados quedarán sin asignar."
    override val eventPlayersTitle = "Jugadores"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total aprobados)"
    override val eventAwaitingPlayers = "Esperando jugadores"
    override val eventAwaitingPlayersSubtitle = "Únete al evento ahora para empezar a formar equipos."
    override val eventAssignToTeam = "Asignar a un equipo"
    override val eventFormatLabel = "Formato:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Cronología"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Entrenador"
    override val eventSaving = "Guardando..."
    override val eventCreating = "Creando..."
    override val eventSaveChanges = "Guardar cambios"
    override val eventCreateEvent = "Crear evento"
    override val eventEditEventTitle = "Editar evento"
    override val eventErrorTitleRequired = "El título es obligatorio"
    override val eventErrorSportRequired = "El deporte es obligatorio"
    override val eventErrorSportNameRequired = "El nombre del deporte es obligatorio"
    override val eventErrorFormatRequiredPro = "El formato es obligatorio para eventos Pro"
    override val eventErrorStartTimeRequired = "La hora de inicio es obligatoria"
    override val eventErrorEndTimeRequired = "La hora de fin es obligatoria"
    override val eventErrorEndAfterStart = "La hora de fin debe ser posterior a la de inicio"
    override val eventErrorStartInPast = "La hora de inicio no puede estar en el pasado"
    override val eventErrorSelectAddress = "Selecciona una dirección"
    override val eventErrorAddressCity = "Elige una dirección válida que incluya una ciudad"
    override val eventErrorCoverRequired = "La foto de portada es obligatoria"
    override val eventErrorSignInEdit = "Inicia sesión para editar eventos"
    override val eventErrorSignInCreate = "Inicia sesión para crear eventos"
    override val eventErrorUploadImage = "No se pudo subir la imagen"
    override val eventErrorSaveChanges = "No se pudieron guardar los cambios"
    override val eventErrorCreateEvent = "No se pudo crear el evento"
    override val eventAddressLabel = "Dirección"
    override val eventAddressPlaceholder = "Buscar dirección..."
    override val eventTitleLabel = "Título"
    override val eventTitlePlaceholder = "p. ej. Partido de fútbol del domingo"
    override val eventSportNameLabel = "Nombre del deporte"
    override val eventSportNamePlaceholder = "Escribe el nombre del deporte"
    override val eventMaxPlayersLabel = "Máx. de jugadores"
    override val eventMaxPlayersPlaceholder = "p. ej. 20"
    override val eventDateLabel = "Fecha"
    override val eventTimeFromLabel = "Desde"
    override val eventTimeToLabel = "Hasta"
    override val eventChooseOnMap = "Elegir en el mapa"
    override val eventConfirmLocation = "Confirmar ubicación"
    override val eventAddPhoto = "Añadir foto"
    override val eventSportLabel = "Deporte"
    override val eventLoading = "Cargando..."
    override val eventSelectSportPlaceholder = "Selecciona un deporte"
    override val eventCommunityLabel = "Comunidad"
    override val eventCommunityNone = "Ninguna (pública)"
    override val eventUnnamedGroup = "Grupo sin nombre"
    override val eventFormatFieldLabel = "Formato"
    override val eventSelectPlaceholder = "Seleccionar"
    override val eventCostLabel = "Costo"
    override val eventPrivateLabel = "Privado"
    override val eventPrivateInfoDescription = "Gestiona tu equipo aprobando manualmente las solicitudes de unión o eliminando participantes."

    // wallet
    override val walletTopUpTitle = "Recargar cartera"
    override val walletSelectAmount = "Selecciona el monto"
    override val walletOr = "o"
    override val walletCustomAmount = "Monto personalizado"
    override val walletEnterAmountPlaceholder = "Escribe el monto"
    override val walletProcessing = "Procesando…"
    override val walletTopUpAction = "Recargar"

    // nav
    override val navDashboard = "Panel"
    override val navClients = "Clientes"
    override val navChat = "Chat"
    override val navSchedule = "Agenda"
    override val navClubSettings = "Ajustes del club"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navPeople = "Personas"
    override val navProfile = "Perfil"
    override val navStatistic = "Estadísticas"
    override val navTeam = "Equipo"
    override val navMedia = "Multimedia"
    override val navWeek = "Semana"
    override val navMonth = "Mes"
    override val navYear = "Año"

    // modal
    override val modalDecline = "Rechazar"
    override val modalCompleteSession = "Completar sesión"
    override val modalTimeAlt = "Hora"
    override val modalPriceAlt = "Precio"
    override val modalBookings = "Reservas"
    override val modalTotalSpent = "Gasto total"
    override val modalSendMessage = "Enviar mensaje"
    override val modalAddNote = "Añadir nota"
    override val modalAdminNotes = "Notas de admin"
    override val modalAdminNotesPrivacy = "Privado - solo visible para admins"
    override val modalWriteNotePlaceholder = "Escribe una nota..."
    override val modalAdd = "Añadir"
    override val modalBookingHistory = "Historial de reservas"
    override val modalNoBookingsYet = "Aún no hay reservas"
    override val modalFieldFallback = "Cancha"
    override val modalStatusConfirmed = "Confirmada"
    override val modalStatusPending = "Pendiente"
    override val modalStatusCompleted = "Completada"
    override val modalStatusCancelled = "Cancelada"
    override val modalPaid = "Pagado"
    override val modalUnpaid = "Sin pagar"

    // feed
    override val feedClubBadge = "Club"
    override fun feedAddAllPhotos(count: Int) = "Añadir las $count foto(s)"
    override val feedUploadFailed = "Error al subir"
    override val feedCreatePostFailed = "No se pudo crear la publicación"
    override val feedCreatePostTitle = "Crear publicación"
    override val feedChooseLayoutSubtitle = "Elige un diseño para tu publicación"
    override val feedFileTooLarge = "Archivo demasiado grande (máx. 50 MB)"
    override val feedChooseLayout = "Elige un diseño"
    override val feedCreating = "Creando..."
    override val feedAddPhoto = "Añadir foto"
    override val feedCityLabel = "Ciudad"
    override val feedEnterCityPlaceholder = "Escribe el nombre de la ciudad..."
    override val feedPostContentLabel = "Contenido de la publicación"
    override val feedPostContentPlaceholder = "Escribe algo sobre esta publicación..."
    override val feedOptional = "(Opcional)"
    override val feedPickPhotoFirst = "Primero elige una foto"
    override val feedCreateStoryFailed = "No se pudo crear la historia"
    override val feedCreateStoriesTitle = "Crear historias"
    override val feedCreateStoriesSubtitle = "Crea y comparte tus momentos"
    override val feedFileTooLargeStory = "Archivo demasiado grande (máx. 30 MB)"
    override val feedDropContentHere = "Arrastra tu contenido aquí"
    override val feedMaxStorySize = " máx. 30 MB"
    override val feedFollowingSection = "Siguiendo"
    override val feedFollowersSection = "Seguidores"
    override val feedSearching = "Buscando…"
    override val feedNoResults = "Sin resultados"
    override val feedLoadingMore = "Cargando más…"
    override val feedThisUser = "este usuario"
    override fun feedUnfollowTitle(name: String) = "¿Dejar de seguir a $name?"
    override val feedUnfollowSubtitle = "Puedes volver a seguir cuando quieras."
    override val feedUnfollow = "Dejar de seguir"
    override fun feedRemoveTitle(name: String) = "¿Eliminar a $name?"
    override val feedRemoveSubtitle = "No recibirá una notificación, pero dejará de ver tus publicaciones."
    override val feedRemove = "Eliminar"
    override val feedFollow = "Seguir"
    override val feedDeleted = "Eliminado"
    override val feedNotFollowingTitle = "Aún no sigues a nadie"
    override val feedNotFollowingBody = "Sigue a jugadores para ver sus publicaciones, momentos destacados e historias en tu feed."
    override val feedNoFollowersTitle = "Aún no tienes seguidores"
    override val feedNoFollowersBody = "Comparte tus publicaciones e historias de partidos para que la comunidad te conozca."
    override val feedDiscoverPlayers = "Descubrir jugadores"

    // dropdown
    override val dropdownAllCities = "Todas las ciudades"
    override val dropdownSelectedAlt = "Seleccionado"

    // page
    override val pageScheduleTitle = "Agenda"
    override val pageScheduleComingSoon = "La vista de agenda llegará pronto"
    override val pageEventsSeoTitle = "Eventos deportivos"
    override val pageEventsSeoDescription = "Explora y únete a eventos deportivos cerca de ti — fútbol, tenis, básquet, pádel y más. Crea tu propio partido e invita a jugadores en Arena."
    override val pageEventsTitle = "Eventos"
    override val pageCreateEvent = "Crear evento"
    override val pageNoEventsYet = "Aún no hay eventos"
    override val pageNotFoundTitle = "Ups, página no encontrada"
    override val pageNotFoundBody = "Revisa que la dirección de la página no tenga errores o vuelve a la arena principal."
    override val pageBackToArena = "Volver a Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Cargando..."
    override val pageSomethingWentWrong = "Algo salió mal"
    override fun pageUnfollowTitle(name: String) = "Dejar de seguir a $name"
    override val pageRemoveFollowerTitle = "¿Eliminar seguidor?"
    override fun pageRemoveFollowerSubtitle(name: String) = "No notificaremos a $name sobre este cambio."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "Descubre qué hace la comunidad deportiva de Arena — resultados de partidos, momentos destacados y momentos compartidos por jugadores cerca de ti."
    override val pageNoPostsYet = "Aún no hay publicaciones"
    override val pageLoadingMore = "Cargando más..."
    override val pagePeopleSeoTitle = "Encuentra jugadores"
    override val pagePeopleSeoDescription = "Descubre deportistas cerca de ti, haz match con jugadores de tu nivel y forma equipo para tu próximo partido en Arena."
    override val pagePeopleTitle = "Personas"
    override val pageSquadUpTitle = "Arma tu equipo"
    override val pageSquadUpSubtitle = "Encuentra compañeros, conecta con jugadores y empieza el juego."
    override val pagePeopleLoadFailed = "No se pudieron cargar las personas"
    override val pagePeopleCaughtUpTitle = "Estás al día por ahora"
    override val pagePeopleCaughtUpSubtitle = "Vuelve más tarde para ver más jugadores."
    override val pageRefresh = "Actualizar"
    override val pageClientsTitle = "Clientes"
    override fun pageClientsTotal(total: Int) = "$total clientes en total"
    override val pageActiveClients = "Clientes activos"
    override val pageTotalBookings = "Reservas totales"
    override val pageTotalRevenue = "Ingresos totales"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Activo"
    override val pageStatusDebtor = "Deudor"
    override val pageStatusAll = "Todos los estados"
    override val pageStatusInactive = "Inactivo"
    override val pageAddNewClient = "Añadir cliente"
    override val pageColName = "Nombre"
    override val pageColRevenue = "Ingresos"
    override val pageColStatus = "Estado"
    override val pageColLastVisit = "Última visita"
    override val pageColActions = "Acciones"
    override val pageUnpaidSuffix = "sin pagar"
    override val pagePrevious = "Anterior"
    override val pagePageLabel = "Página"
    override val pageOfLabel = "de"
    override val pageBackToEvents = "Volver a eventos"
    override val pageResetTimerTitle = "¿Reiniciar el reloj?"
    override val pageResetTimerMessage = "El reloj del partido volverá a 00:00. Las estadísticas registradas se conservan."
    override val pageResetTimerConfirm = "Reiniciar"
    override val pageResetting = "Reiniciando..."
    override val pageEndMatchTitle = "¿Terminar el partido?"
    override val pageEndMatchMessage = "El evento se marcará como finalizado y los marcadores quedarán bloqueados."
    override val pageEndMatchConfirm = "Terminar partido"
    override val pageEnding = "Terminando..."
    override val pageAddMedia = "Añadir multimedia"
    override val pageBook = "Reservar"
    override val pageCourtRules = "Reglas de la cancha"
    override val pageNoCourtRules = "No hay reglas de cancha especificadas."
    override val pageLeaveReview = "Dejar una reseña"
    override val pageNoReviewsYet = "Aún no hay reseñas."
    override val pageSportFootball = "Fútbol"
    override val pageSportBasketball = "Básquet"
    override val pageSportTennis = "Tenis"
    override val pageSportPadel = "Pádel"
    override val pageClubFallback = "Club"
    override fun pageReviewExperienceTitle(sportName: String) = "¿Qué tal tu experiencia de $sportName?"
    override val pageWriteReviewPlaceholder = "Escribe tu reseña..."
    override val pagePosting = "Publicando..."
    override val pagePostReview = "Publicar reseña"
    override val pageLoadMore = "Cargar más"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Tu carrera deportiva de un vistazo — estadísticas, valoraciones y logros en fútbol, tenis, básquet y más en Arena."
    override val pageEventsTab = "Eventos"
    override val pageClubsTab = "Clubes"
    override val pageFilterLocation = "Ubicación"
    override val pageUnnamedCommunity = "Sin nombre"
    override val pageFilterCommunity = "Comunidad"
    override val pageFilterAll = "Todos"
    override val pageFilterCalendar = "Calendario"
    override val pageAddEvent = "Añadir evento"
    override val pageAddClub = "Añadir club"
    override val pageMap = "Mapa"
    override val pageOwnTheArena = "DOMINA LA ARENA"
    override val pageArenaBannerSubtitle = "Tu arena te espera. Reserva al instante — juega con confianza."
    override val pageLoadingMoreEvents = "Cargando más eventos..."
    override val pageLoadingMoreClubs = "Cargando más clubes..."
    override val pageNoClubsYet = "Aún no hay clubes"
    override val pageClubsWillAppear = "Los clubes aparecerán aquí"
    override val pageEventsMapTitle = "Mapa de eventos"
    override val pageClubsMapTitle = "Mapa de clubes"
    override val pageDeleteClub = "Eliminar club"
    override val pageAddBanner = "Añadir banner"
    override val pageRulePlaceholder = "p. ej. Ropa deportiva obligatoria"
    override val pageAddRule = "Añadir regla"
    override val pageEditServices = "Editar servicios"
    override val pageManageServices = "Gestionar servicios"
    override val pageAmenityParking = "Estacionamiento"
    override val pageAmenityCafe = "Cafetería"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Recepción"
    override val pageAmenityShower = "Duchas"
    override val pageAmenityFirstAid = "Primeros auxilios"
    override val pageReviewsLabel = "Reseñas:"
    override val pageAvgRatingLabel = "Val. media:"
    override val pageReviewsPlaceholderNote = "Las reseñas aparecerán aquí cuando los usuarios dejen su opinión."
    override val pageClubComposePrompt = "¿Qué pasa en tu club?"
    override val pageClubNoPostsHint = "Comparte una foto y una idea rápida para mantener activo el club."
    override val pageComposePostTitle = "Redactar publicación"
    override val pagePostContentPlaceholder = "Contenido de la publicación..."
    override fun pageAddImageSlot(slot: Int) = "Añadir imagen $slot"
    override val pagePostAction = "Publicar"
    override val pageEditClubInfo = "Editar info del club"
    override val pageClubNameLabel = "Nombre del club"
    override val pageAddressLabel = "Dirección"
    override val pageSearchAddressPlaceholder = "Buscar dirección"
    override val pageSaveChanges = "Guardar cambios"

    // account
    override val accountRequiredTitle = "Cuenta requerida"
    override val accountRequiredDescription = "Esta función es solo para jugadores registrados. Inicia sesión con Google o Apple para continuar."
    override val accountRequiredTermsPrefix = "Al continuar aceptas nuestros "
    override val accountRequiredTerms = "Términos"
    override val accountRequiredPrivacy = "Privacidad"

    // avatar
    override val avatarGenTitle = "Avatar IA"
    override val avatarGenErrorFileType = "Solo se permiten archivos JPEG, PNG y WebP"
    override val avatarGenErrorFileSize = "El archivo debe pesar menos de 30 MB"
    override val avatarGenGenerating = "Generando…"
    override val avatarGenGenerate = "Generar"
    override fun avatarGenGenerateWithPrice(price: String) = "Generar · $price"
    override val avatarGenGeneratedLook = "Look generado"
    override val avatarGenDropPhotoHere = "Arrastra tu foto aquí"
    override val avatarGenMaxFileSize = "máx. 30 MB"
    override val avatarGenReadyToGenerate = "Listo para generar"
    override val avatarGenCustomPrompt = "Prompt personalizado"
    override val avatarGenPromptPlaceholder = "Añade detalles para definir el estilo ..."
    override val avatarGenInfoDefaultBehavior = "Por defecto, la IA te recortará de la foto y te colocará en la carta."
    override val avatarGenInfoPromptIntro = "En el prompt también puedes pedir:"
    override val avatarGenInfoBulletZoom = "Acercar o alejar la figura"
    override val avatarGenInfoBulletObject = "Añadir o quitar un objeto (p. ej. lentes de sol, camiseta, balón, gorra)"
    override val avatarGenOptionalBadge = "(Opcional)"

    // card
    override val cardLifeTitle = "Dale vida a tu carta"
    override val cardLifeSubtitle = "Crea tu identidad visual"
    override val cardLifeMyStyles = "Mis estilos"
    override val cardLifeSelectToGenerate = "Selecciona para generar"
    override val cardLifeActiveCards = "Cartas de perfil activas"
    override val cardLifeDragToReorder = "Arrastra para reordenar"
    override val cardLifeNoTemplates = "Aún no tienes plantillas de carta. Consigue una en la tienda de cartas."
    override val cardLifeCreatePhoto = "Crear foto"
    override val cardLifeDeleteCardTitle = "¿Eliminar carta?"
    override val cardLifeDeleteCardMessage = "Esto elimina la carta de tu galería. La plantilla se mantiene en tus estilos."

    // wallet
    override val walletTitle = "Mi cartera"
    override val walletCredits = "Créditos"
    override val walletSignInToBuy = "Inicia sesión para comprar créditos."
    override fun walletCreditsAdded(amount: Int) = "$amount créditos añadidos a tu cartera."
    override val walletPurchaseFailed = "La compra falló. Inténtalo de nuevo."
    override fun walletBuyFor(price: String) = "Comprar por $price"
    override val walletBackToPackages = "Volver a los paquetes"
    override val walletSelectedPack = "Paquete seleccionado"
    override fun walletOneTimePurchase(currency: String) = "$currency · Compra única"
    override val walletCurrentBalance = "Saldo actual"
    override val walletNewBalance = "Nuevo saldo"
    override val walletSecuredNote = "Seguro · Sin cargos recurrentes"
    override val walletPaymentMethod = "Método de pago"
    override val walletOrPayWithCard = "O paga con tarjeta"
    override val walletCardNumber = "Número de tarjeta"
    override val walletExpiryDate = "Fecha de caducidad"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Confirmar y pagar €$price"

    // complete
    override val completeProfileTitle = "Completa tu perfil para empezar a deslizar"
    override val completeProfileDescription = "Completa tu perfil para ver jugadores que coincidan con tu nivel e intereses."
    override val completeProfileMaybeLater = "Quizás más tarde"
    override val completeProfileAction = "Completar perfil"

    // preference
    override val preferenceDetailsTitle = "Detalles de preferencias"

    // follow
    override val followListFollowers = "Seguidores"
    override val followListFollowing = "Siguiendo"
    override val followListNoResults = "Sin resultados"
    override val followListNoFollowersYet = "Aún no tienes seguidores"
    override val followListNotFollowingAnyoneYet = "Aún no sigues a nadie"
    override val followListUnfollow = "Dejar de seguir"
    override val followListFollow = "Seguir"
    override val followListRemove = "Eliminar"
    override val followListDeleted = "Eliminado"

    // top
    override val topUpTitle = "Recarga tu cartera"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "Necesitas $required para $action, pero tu cartera tiene $balance."
    override val topUpChooseAmount = "Elige el monto"
    override val topUpOr = "o"
    override val topUpCustomAmount = "Monto personalizado"
    override val topUpEnterAmountPlaceholder = "Escribe el monto"
    override val topUpAction = "Recargar"
    override val topUpFailed = "La recarga falló"

    // interactions
    override val interactionsTitle = "Interacciones"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes me gusta nuevos · $matches matches"
    override val interactionsNewLikes = "Me gusta nuevos"
    override val interactionsNoNewLikesTitle = "Aún no hay me gusta nuevos"
    override val interactionsNoNewLikesMessage = "Cuando alguien te dé un Sí, aparecerá aquí."
    override val interactionsMatches = "Matches"
    override val interactionsNoMatchesTitle = "Aún no hay matches"
    override val interactionsNoMatchesMessage = "Dale un Sí a alguien que ya te dio like para conseguir un match."

    // match
    override val matchItsWord = "¡Es un"
    override val matchWord = "MATCH!"
    override val matchSubtitle = "Es momento de conectar y planear el juego."
    override val matchKeepSwiping = "Seguir deslizando"
    override val matchGoToProfile = "Ir al perfil"
    override val matchYouFallback = "Tú"

    // purchase
    override val purchaseCardTitle = "¿Quieres esta carta?"
    override val purchaseCardBuying = "Comprando…"
    override val purchaseCardBuyNow = "Comprar ahora"

    // post
    override val postCommentsLike = "Me gusta"
    override val postCommentsOneLike = "1 me gusta"
    override fun postCommentsLikes(count: Int) = "$count me gusta"
    override val postCommentsInputPlaceholder = "Escribe un mensaje…"

    // story
    override fun storySeenBy(count: Int) = "Visto por $count"

    // support
    override val supportTitle = "Contactar con soporte"
    override val supportIntro = "Cuéntanos qué salió mal o en qué necesitas ayuda — te responderemos por correo."
    override val supportEmailLabel = "Tu correo"
    override val supportMessageLabel = "Mensaje"
    override val supportMessagePlaceholder = "Describe tu problema…"
    override val supportErrorInvalidEmail = "Escribe un correo válido."
    override val supportErrorEmptyMessage = "Escribe un mensaje."
    override val supportErrorGeneric = "Algo salió mal. Inténtalo de nuevo."
    override val supportSending = "Enviando…"
    override val supportSendMessage = "Enviar mensaje"
    override val supportSentTitle = "¡Mensaje enviado!"
    override val supportSentMessage = "Gracias por escribirnos — te responderemos pronto a tu correo."

    // person
    override val personDetailTabAbout = "Acerca de"
    override val personDetailTabPosts = "Publicaciones"
    override val personDetailTabAchievement = "Logros"
    override val personDetailAchievementsComingSoon = "Los logros llegarán pronto."
    override val personDetailFollowing = "Siguiendo"
    override val personDetailFollowers = "Seguidores"
    override val personDetailSportLabel = "Deporte:"
    override val personDetailActivityLabel = "Actividad:"
    override val personDetailLifestyleLabel = "Estilo de vida:"
    override val personDetailNoPostsTitle = "Aún no hay publicaciones"
    override val personDetailNoPostsMessage = "Este jugador aún no ha publicado nada."

    // common
    override val commonClose = "Cerrar"
    override val commonDone = "Listo"
    override val commonLoading = "Cargando…"
    override val commonBack = "Atrás"
    override val commonSkip = "Omitir"

    // profile
    override val profileCardShopLoading = "Cargando..."
    override val profileCardShopEmpty = "No hay cartas disponibles"
    override val profileCardShopBuy = "Comprar"
    override val profileCardShopFree = "Gratis"
    override val profileFormationReservePlate = "Res"
    override val profileFormationCoach = "Entrenador"
    override val profileMediaEmpty = "Aún no hay multimedia"
    override val profileMediaImageAlt = "multimedia"
    override val profileNewsPrompt = "¿Qué estás pensando?"
    override val profileNewsLoading = "Cargando..."
    override val profileNewsLoginRequired = "Inicia sesión para ver tus publicaciones"
    override val profileNewsEmpty = "Aún no hay publicaciones. ¡Comparte algo!"
    override val profileNewsPlaceholder = "Escribe algo..."
    override val profileNewsPosting = "Publicando..."
    override val profileNewsPost = "Publicar"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Eventos recientes"
    override val profileRecentMatchesEmptyTitle = "Aún no hay eventos programados"
    override val profileRecentMatchesEmptyHint = "¡Elige un evento próximo y únete a la acción!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Equipo A"
    override val profileRecentMatchesTeamB = "Equipo B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count pers."
    override val profileRecentMatchesWin = "Victoria"
    override val profileRecentMatchesLoss = "Derrota"
    override val profileRecentMatchesDraw = "Empate"
    override val profileRecentMatchesSportFallback = "Deporte"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Formato $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count miembros"
    override val profileShortcutStatistic = "Estadísticas"
    override val profileShortcutMedia = "Multimedia"
    override val profileStatsChartsGoals = "Goles"
    override val profileStatsChartsAssists = "Asistencias"
    override val profileStatsChartsPerYear = "por año"
    override val profileStatsChartsPerWeek = "por semana"
    override val profileStatsChartsPerMonth = "por mes"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "No hay datos disponibles"
    override val profileTeamEmptyOwnTitle = "Aún no tienes equipo"
    override val profileTeamEmptyOtherTitle = "Sin equipo"
    override val profileTeamEmptyCreateTeam = "Crear equipo"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Mapa mundial"
    override val profileTeamMatchesEmpty = "Aún no hay partidos"
    override val profileTeamMatchesUpcomingTitle = "Próximos partidos"
    override val profileTeamMatchesUpcomingEmpty = "No hay próximos partidos"
    override val profileTeamMatchesVenueAlt = "Sede"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count equipos"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total miembros"
    override fun profileTeamMatchesFormat(format: Int) = "Formato ${format}x${format}"
    override val profileTeamOverviewTitle = "Resumen del equipo"
    override val profileTeamOverviewClubTitle = "Club de fútbol"
    override val profileTeamOverviewRating = "Valoración"
    override val profileTeamOverviewTeamRating = "Valoración del equipo"
    override val profileTeamOverviewStatistics = "Estadísticas"
    override val profileTeamOverviewWins = "Victorias"
    override val profileTeamOverviewDraws = "Empates"
    override val profileTeamOverviewLosses = "Derrotas"
    override val profileSidebarTitle = "Resumen"
    override val profileSidebarFollowing = "Siguiendo"
    override val profileSidebarFollowers = "Seguidores"
    override val profileSidebarAchievement = "Logros"
    override val profileSidebarAboutYouEmpty = "Añade unas palabras sobre ti para presentar tu perfil"
    override val profileSidebarFocusActivities = "Enfoque y actividades"
    override val profileSidebarSportLabel = "Deporte"
    override val profileSidebarActivityLabel = "Actividad"
    override val profileSidebarLifestyleLabel = "Estilo de vida"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Seguir"
    override val profileSidebarUnfollow = "Dejar de seguir"
    override val profileSidebarNoInterests = "No hay intereses añadidos"
    override val profileSidebarNoInterestsBody = "Muestra a los demás tus hobbies y deportes."
    override val profileHubTitle = "Centro del jugador"
    override val profileHubYourStories = "Tus historias"
    override val profileHubStories = "Historias"
    override val profileHubCardShopUnavailable = "Tienda de cartas no disponible"
    override val profileHubCardShopTitle = "Tienda de cartas"
    override val profileHubCardShopSubtitle = "Compra cartas nuevas. Define tu estilo."
    override val profileHubActiveBought = "Activas y compradas"
    override fun profileHubOwnedCount(count: Int) = "$count adquiridas"
    override val profileHubNoCardsYet = "Aún no hay cartas"
    override val profileHubAvailableForPurchase = "Disponibles para comprar"
    override val profileHubNewDesignsRegularly = "Nuevos diseños con regularidad"
    override val profileHubAllCardsOwned = "Ya tienes todas las cartas"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat por $period"
    override val profileHubNoChartsTitle = "No hay gráficos disponibles"
    override val profileHubNoChartsBody = "Elige un deporte específico en el encabezado para ver goles, asistencias, partidos y el resto de tus estadísticas."
    override val profileHubContentTitle = "Contenido"
    override val profileHubLoading = "Cargando..."
    override val profileHubAddStory = "Añadir historia"
    override val profileHubAddPost = "Añadir publicación"
    override val profileHubUserFallback = "usuario"
    override val profileHubNoPostsYet = "Aún no hay publicaciones"
    override val profileHubShareFirstMoment = "Comparte tu primer momento"
    override val profileHubPlayerNotPosted = "Este jugador aún no ha publicado."
    override val profileOverviewTitle = "Resumen del jugador"
    override val profileOverviewPlayerIdentify = "Identidad del jugador"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "Avatar IA"
    override val profileOverviewGoals = "Goles"
    override val profileOverviewGoalsUnit = "goles"
    override val profileOverviewWins = "Victorias"
    override val profileOverviewWinsUnit = "victorias"
    override val profileOverviewDraws = "Empates"
    override val profileOverviewDrawsUnit = "empates"
    override val profileOverviewLosses = "Derrotas"
    override val profileOverviewLossesUnit = "derrotas"
    override val profileOverviewAchievements = "Logros"
    override val profileOverviewNotFollowingAnyone = "Aún no sigues a nadie"
    override val profileOverviewComingSoon = "Próximamente"
    override val profileAwardsEmpty = "Aún no hay premios"
    override val awardWelcomeTitle = "Premio de bienvenida"
    override val awardTermScorerFootball = "Máximo goleador"
    override val awardTermAssistFootball = "Máximo asistente"
    override val awardTermScorerBasketball = "Máximo anotador"
    override val awardTermAssistBasketball = "Máximo asistente"
    override val awardTermScorerTennis = "Más winners"
    override val awardTermAssistTennis = "Más aces"
    override val awardTermScorerVolleyball = "Mejor atacante"
    override val awardTermAssistVolleyball = "Máximo asistente"
    override val awardTermScorerPadel = "Más winners"
    override val awardTermAssistPadel = "Más remates"
    override val awardTermScorerGeneric = "Máximo goleador"
    override val awardTermAssistGeneric = "Máximo asistente"
    override val awardRank1 = "1.er puesto"
    override val awardRank2 = "2.º puesto"
    override val awardRank3 = "3.er puesto"
    override val profileOverviewAddPost = "Añadir publicación"
    override val profileOverviewWritePlaceholder = "Escribe algo..."
    override val profileOverviewPost = "Publicar"
    override val profileOverviewLoading = "Cargando..."
    override val profileOverviewLoginToSeePosts = "Inicia sesión para ver publicaciones"
    override val profileOverviewNoPostsYet = "Aún no hay publicaciones"
    override val profileWizardLetsGo = "¡Vamos!"
    override val profileWizardStepPersonalInfoTitle = "Datos personales"
    override val profileWizardStepPersonalInfoDescription = "Cuéntanos sobre ti para empezar."
    override val profileWizardStepFocusTitle = "Enfoque y actividades"
    override val profileWizardStepFocusDescription = "Elige tus deportes y estilo de vida"
    override val profileWizardStepCardTitle = "Dale vida a tu carta"
    override val profileWizardStepCardDescription = "Crea tu identidad visual"
    override fun profileWizardSelectedCount(count: Int) = "$count seleccionados"
    override val profileWizardPublicInfo = "Info pública"
    override val profileWizardMyStyles = "Mis estilos"
    override val profileWizardSelectToGenerate = "Selecciona para generar"
    override val profileWizardNoTemplates = "Aún no hay plantillas de carta disponibles."
    override val profileWizardActiveCards = "Cartas de perfil activas"
    override val profileWizardDragToReorder = "Arrastra para reordenar"
    override fun profileWizardCardCount(count: Int) = "$count carta${if (count == 1) "" else "s"}"
    override val profileWizardCreatePhoto = "Crear foto"
    override val profileFocusEditTitle = "Enfoque y actividades"
    override val profileFocusEditDescription = "Elige tus deportes y estilo de vida para definir tu identidad."
    override val profileFocusEditSelectedLabel = "seleccionados"
    override val profileFocusEditClearAll = "Borrar todo"
    override val profileFocusEditSearchPlaceholder = "Buscar atributos…"
    override val profileFocusEditSportLabel = "Deporte"
    override val profileFocusEditActivityLabel = "Actividad"
    override val profileFocusEditLifestyleLabel = "Estilo de vida"
    override val profileFocusEditNoMatches = "Sin coincidencias"
    override val profileFocusEditPreferenceDetails = "Detalles de preferencias"
    override val profileFocusEditPreferenceHint = "Opcional, pero te ayuda a encontrar personas afines más rápido."
    override val profileFocusEditNoteLabel = "Nota"
    override val profileFocusEditNotePlaceholder = "¿Qué estás buscando?"
    override val profileFocusEditAddDetails = "Añadir detalles"
    override val profilePersonalEditTitle = "Datos personales"
    override val profilePersonalEditDescription = "Cuéntanos sobre ti para empezar."
    override val profilePersonalEditFirstNameLabel = "Nombre"
    override val profilePersonalEditLastNameLabel = "Apellido"
    override val profilePersonalEditAboutMeLabel = "Sobre mí"
    override val profilePersonalEditBioPlaceholder = "Cuéntales a otros jugadores un poco sobre ti…"
    override val profilePersonalEditDobLabel = "Fecha de nacimiento"
    override val profilePersonalEditCityLabel = "Ciudad"
    override val profilePersonalEditCitySearchPlaceholder = "Buscar ciudad…"
    override val profilePersonalEditLanguagesLabel = "Idiomas"
    override val profilePersonalEditTypeLanguagePlaceholder = "Escribe un idioma…"
    override val profilePersonalEditAddLanguagePlaceholder = "Añadir idioma…"
    override val profileEditSheetPublicInfo = "Info pública"
    override val profileEditShellPublicInfo = "Info pública"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Añadir las $count foto(s)"
    override val profileCreatePostUploadFailed = "Error al subir"
    override val profileCreatePostCreateFailed = "No se pudo crear la publicación"
    override val profileCreatePostTitle = "Crear publicación"
    override val profileCreatePostChooseLayout = "Elige un diseño"
    override val profileCreatePostFileTooLarge = "Archivo demasiado grande (máx. 50 MB)"
    override val profileCreatePostCreating = "Creando..."
    override val profileCreatePostAddPhoto = "Añadir foto"
    override val profileCreatePostContentLabel = "Contenido de la publicación"
    override val profileCreatePostContentPlaceholder = "Escribe algo sobre esta publicación..."
    override val profileCreatePostCityLabel = "Ciudad"
    override val profileCreatePostCityPlaceholder = "Escribe el nombre de la ciudad..."
    override val profileCreateStoryPickPhotoFirst = "Primero elige una foto"
    override val profileCreateStoryUploadFailed = "Error al subir"
    override val profileCreateStoryCreateFailed = "No se pudo crear la historia"
    override val profileCreateStoryTitle = "Crear historias"
    override val profileCreateStorySubtitle = "Crea y comparte tus momentos"
    override val profileCreateStoryFileTooLarge = "Archivo demasiado grande (máx. 30 MB)"
    override val profileCreateStoryCreating = "Creando..."
    override val profileCreateStoryDropHere = "Arrastra tu contenido aquí"
    override val profileCreateStoryMaxSize = " máx. 30 MB"
    override val profileFollowListFollowers = "Seguidores"
    override val profileFollowListFollowing = "Siguiendo"
    override val profileFollowListNoResults = "Sin resultados"
    override val profileFollowListUnfollow = "Dejar de seguir"
    override val profileFollowListFollow = "Seguir"
    override val profileFollowListRemoved = "Eliminado"
    override val profileFollowListRemove = "Eliminar"
    override val profileFollowListNotFollowingTitle = "Aún no sigues a nadie"
    override val profileFollowListNotFollowingBody = "Sigue a jugadores para ver sus publicaciones, momentos destacados e historias en tu feed."
    override val profileFollowListDiscoverPlayers = "Descubrir jugadores"
    override val profileFollowListNoFollowersTitle = "Aún no tienes seguidores"
    override val profileFollowListNoFollowersBody = "Comparte tus publicaciones e historias de partidos para que la comunidad te conozca."
    override val profileDialogPreferenceDetails = "Detalles de preferencias"
    override val profileStoryViewersTitle = "¿Quién vio esta historia?"
    override val profileStoryViewersNoViews = "Aún no hay vistas"
    override val profileContentMobileOverview = "Resumen"
    override val profileContentMobileFollowing = "Siguiendo"
    override val profileContentMobileFollowers = "Seguidores"
    override val profileContentMobileAwardsComingSoon = "Premios próximamente"
    override val profileContentMobileRecentEvents = "Eventos recientes"
    override val profileContentMobileNoEvents = "Aún no hay eventos programados"
    override val profileContentMobileNoEventsBody = "¡Elige un evento próximo y únete a la acción!"
    override val profileContentMobileResultWin = "Victoria"
    override val profileContentMobileResultDraw = "Empate"
    override val profileContentMobileResultLoss = "Derrota"
    override val profileContentMobileSportFallback = "Deporte"
    override fun profileContentMobileFormat(format: Int) = "Formato $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count miembros"
    override val profileContentMobilePlayerHub = "Centro del jugador"
    override val profileContentMobileNoPostsTitle = "Aún no hay publicaciones"
    override val profileContentMobileNoPostsOwnBody = "Comparte fotos y momentos destacados de partidos para llenar tu perfil."
    override val profileContentMobileNoPostsOtherBody = "Este jugador aún no ha publicado nada."
    override val profileContentMobileCardsUnavailable = "Cartas no disponibles"
    override val profileContentMobileCardsLoadFailed = "No se pudieron cargar las cartas"
    override val profileContentMobileNoCardsAvailable = "No hay cartas disponibles"
    override val profileContentMobileActiveBought = "Activas y compradas"
    override fun profileContentMobileOwnedCount(count: Int) = "$count adquiridas"
    override val profileContentMobileAvailableForPurchase = "Disponibles para comprar"
    override val profileContentMobileNewDesigns = "Nuevos diseños con regularidad"
    override val profileContentMobileNoCardsYet = "Aún no hay cartas"
    override val profileContentMobileCardsTitle = "Cartas"
    override val profileContentMobileAddPost = "Añadir publicación"
    override val profileContentMobileUserFallback = "usuario"
    override val profileUserSheetError = "Algo salió mal"
    override val profileUserSheetThisUser = "este usuario"
    override fun profileUserSheetUnfollowTitle(name: String) = "¿Dejar de seguir a $name?"
    override val profileUserSheetRefollowHint = "Puedes volver a seguir cuando quieras."
    override val profileUserSheetUnfollow = "Dejar de seguir"

    // header
    override val headerNavHome = "Inicio"
    override val headerNavAbout = "Acerca de"
    override val headerNavServices = "Servicios"
    override val headerNavProjects = "Proyectos"
    override val headerNavContacts = "Contactos"
    override val headerSportLabel = "Deporte:"
    override val headerUserFallbackName = "Usuario"
    override val headerNoActiveEvents = "No hay eventos ni reservas activos"
    override val headerNoNotifications = "No hay notificaciones"
    override val headerYourActiveEvents = "Tus eventos activos "
    override val headerNotificationsTitle = "Notificaciones "
    override val headerMarkAllRead = "Marcar todo como leído"
    override val headerLoadMore = "Cargar más"
    override val headerPendingApproval = "Pendiente de aprobación"
    override val headerEventStatusNew = "Nuevo"
    override val headerEventStatusInProgress = "En curso"
    override val headerEventStatusCompleted = "Finalizado"
    override val headerEventStatusCancelled = "Cancelado"
    override val headerBookingFallback = "Reserva"
    override val headerActionView = "Ver"
    override val headerActionReply = "Responder"
    override val headerActionUnfollow = "Dejar de seguir"
    override val headerActionFollowBack = "Seguir también"
    override val headerActionAccept = "Aceptar"
    override val headerActionDecline = "Rechazar"
    override val headerConfirmTitle = "¿Estás seguro?"
    override val headerSignOutConfirmMessage = "Se cerrará tu sesión de Arena en este dispositivo. Tus datos están a salvo."
    override val headerSignOutConfirmLabel = "Cerrar sesión"
    override val headerDeleteConfirmMessage = "Eliminar tu perfil es permanente. Se borrarán todos los créditos, momentos y estadísticas."
    override val headerDeleteConfirmLabel = "Confirmar eliminación"
    override val headerDeleteProfileFailed = "No se pudo eliminar tu perfil. Inténtalo de nuevo."
    override val headerUploading = "Subiendo..."
    override val headerVisualStyle = "Estilo visual"
    override val headerSyncWithSportType = "Sincronizar con el deporte"
    override val headerMyWallet = "Mi cartera"
    override val headerSignOut = "Cerrar sesión"
    override val headerSigningOut = "Cerrando sesión..."
    override val headerDeleteProfile = "Eliminar perfil"
    override val headerRequestNoLongerAvailable = "Esta solicitud ya no está disponible."
    override val headerRequestProcessFailed = "No se pudo procesar la solicitud. Inténtalo de nuevo."
    override val headerSelectClub = "Seleccionar club"
    override val headerAddClub = "Añadir club"
    override val headerSwitchToPlayer = "Cambiar a jugador"
    override val headerLogout = "Salir"
    override val headerLoggingOut = "Saliendo..."
    override val headerSigningIn = "Iniciando sesión..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "une a"
    override val homeHeroAthletes = "atletas"
    override val homeHeroAndTeams = "y equipos"
    override val homeHeroWorldwideFor = "de todo el mundo para"
    override val homeSectionCreateEventsTitle = "Crea eventos"
    override val homeSectionCreateEventsHighlight = "eventos"
    override val homeSectionCreateEventsSubtitle1 = "Elige el deporte, define el horario"
    override val homeSectionCreateEventsSubtitle2 = "y añade la ubicación del partido."
    override val homeSectionTeammatesTitle = "Descubre compañeros perfectos"
    override val homeSectionTeammatesHighlight = "compañeros"
    override val homeSectionMomentsTitle = "Comparte momentos, conecta con amigos"
    override val homeSectionMomentsHighlight = "amigos"
    override val homeSectionStatsTitle = "Sigue tus estadísticas, evoluciona tu progreso y personaliza tu carta"
    override val homeSectionStatsHighlight = "progreso"
    override val homeAltEventsScreen = "Pantalla de eventos"
    override val homeAltCreateEventScreen = "Pantalla de crear evento"
    override val homeAltCreateEventModal = "Modal de crear evento"
    override val homeAltEventDetailScreen = "Pantalla de detalle del evento"
    override val homeAltDiscoverPeople = "Descubrir personas"
    override val homeAltPlayerDiscoveryCard = "Carta de descubrimiento de jugador"
    override val homeAltMatchedInterests = "Intereses en común"
    override val homeAltMatchedInterestsModal = "Modal de intereses en común"
    override val homeAltItsAMatch = "Es un match"
    override val homeAltFeedScreen = "Pantalla del feed"
    override val homeAltFeedPost = "Publicación del feed"
    override val homeAltGameMomentsPost = "Publicación de momentos del juego"
    override val homeAltChatScreen = "Pantalla del chat"
    override val homeAltProfileOverview = "Resumen del perfil"
    override val homeAltProfileDashboard = "Panel del perfil"
    override val homeAltPlayerStatsRadar = "Radar de estadísticas del jugador"
    override val homeAltPlayerStatsCard = "Carta de estadísticas del jugador"
    override val homeAltRatePerformance = "Calificar desempeño"
    override val homeAltRatePerformanceModal = "Modal de calificar desempeño"
    override val homeItsYourMatch = "¡Es tu match!"
    override val homeLabelGameMoments = "Momentos del juego"
    override val homeLabelPlayerStats = "Estadísticas del jugador"
    override val homeLabelRatePerformance = "Calificar desempeño"
    override val homeFooterTagline = "Tu comunidad deportiva global"
    override val homeFooterBlurb = "Encuentra personas cerca de ti para jugar fútbol, tenis, básquet, pádel o vóley — únete a partidos improvisados y eventos deportivos locales, o crea el tuyo en Arena."
    override val homeFooterAbout = "Acerca de"
    override val homeFooterTerms = "Términos del servicio"
    override val homeFooterPrivacy = "Política de privacidad"
    override val homeFooterPricing = "Precios"
    override val homeFooterRefund = "Política de reembolso"
    override val homeFooterSupports = "Soporte"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "DESCÁRGALO EN"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "DISPONIBLE EN"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Analíticas"
    override val dashboardTabSchedule = "Agenda"
    override val dashboardRatingTitle = "Valoración"
    override val dashboardReviews = "reseñas"
    override val dashboardAvgDuration = "Duración media"
    override val dashboardTotalRevenue = "Ingresos totales"
    override val dashboardTotalBookings = "Reservas totales"
    override val dashboardArenaSchedule = "Agenda de la arena"
    override val dashboardThisWeek = "Esta semana"
    override val dashboardAddEvent = "Añadir evento"
    override val dashboardTimeHeader = "Hora"
    override val dashboardCustomerFallback = "Cliente"
    override val dashboardRevenueTitle = "Ingresos"
    override val dashboardBookingsTitle = "Reservas"
    override val dashboardBookingStatusTitle = "Estado de reservas"
    override val dashboardBookingHeatmapTitle = "Mapa de calor de reservas"
    override val dashboardDonutTotal = "Total"
    override val dashboardBookingsTooltipPrefix = "Reservas "
    override val dashboardStatusConfirmed = "Confirmadas"
    override val dashboardStatusCompleted = "Completadas"
    override val dashboardStatusPending = "Pendientes"
    override val dashboardStatusUnpaid = "Sin pagar"
    override val dashboardStatusDeclined = "Rechazadas"
    override val dashboardNoData = "Sin datos"
    override val dashboardDayMon = "Lun"
    override val dashboardDayTue = "Mar"
    override val dashboardDayWed = "Mié"
    override val dashboardDayThu = "Jue"
    override val dashboardDayFri = "Vie"
    override val dashboardDaySat = "Sáb"
    override val dashboardDaySun = "Dom"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count reservas"

    // arena
    override val arenaActionViewResults = "Ver resultados"
    override val arenaActionWatchLive = "Ver en vivo"
    override val arenaActionJoinNow = "Únete ahora"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Nuevo"
    override val arenaStatusCompleted = "Finalizado"
    override val arenaStatusCanceled = "Cancelado"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total miembros"
    override fun arenaMembersCount(count: Int) = "$count miembros"
    override fun arenaTeamsCount(count: Int) = "$count equipos"
    override fun arenaFormat(format: String) = "Formato $format"
    override fun arenaFinalScore(score: String) = "Resultado final $score"
    override fun arenaDuration(duration: String) = "Duración $duration"
    override val arenaLoadingClubs = "Cargando clubes..."
    override val arenaLoadingMoreEvents = "Cargando más eventos..."
    override val arenaLoadingMoreClubs = "Cargando más clubes..."
    override val arenaLocationLabel = "Ubicación: "
    override val arenaAllCities = "Todas las ciudades"
    override val arenaCommunityAll = "Todas"
    override val arenaCommunityUnnamed = "Sin nombre"
    override val arenaTabClubs = "Clubes"
    override val arenaTabEvents = "Eventos"
    override val arenaEmptyTitle = "Aún no hay eventos programados"
    override val arenaEmptySubtitle = "Crea un evento con chat del partido y seguimiento en tiempo real."
    override val arenaAddEvent = "Añadir evento"
    override val arenaNoClubsTitle = "Aún no hay clubes"
    override val arenaNoClubsSubtitle = "Los clubes aparecerán aquí"

    // people
    override val peopleErrorLoad = "No se pudieron cargar las personas"
    override val peopleCaughtUpTitle = "Estás al día"
    override val peopleCaughtUpSubtitle = "Vuelve más tarde para ver más jugadores."
    override val peopleRefresh = "Actualizar"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Tu feed está vacío"
    override val feedEmptySubtitle = "Sigue a jugadores para ver sus publicaciones e historias aquí."
    override val feedNoCommentsTitle = "Aún no hay comentarios"
    override val feedNoCommentsSubtitle = "Sé el primero en comentar."
    override val feedMessagePlaceholder = "Escribe un mensaje..."
    override val feedLikeZero = "Me gusta"
    override val feedLikeOne = "1 me gusta"
    override fun feedLikeMany(count: Int) = "$count me gusta"

    // auth
    override val authWelcomeTitle = "¡Bienvenido a Arena!"
    override val authWelcomeSubtitle = "Inicia sesión con Google o Apple para crear tu perfil, desbloquear esta página y comenzar tu camino deportivo con nosotros."
    override val authAgreePrefix = "Al continuar aceptas nuestros"
    override val authTerms = "Términos"
    override val authPrivacy = "Privacidad"

    // layout
    override val layoutComingSoon = "Próximamente"
}
